import { createTypes } from "redux-action-types";
import api from "../api";

export const types = createTypes("fridge/users/", "LOAD", "SAVE", "DELETE");

export const load = async (role) => {
  const users = await api.get(`roles/${role.id}/users`, { active: "all" });
  return { type: types.LOAD, data: { users, role } };
};

export const save = async (data, role) => {
  const user = data.id
    ? await api.put(`roles/${role.id}/users/${data.id}`, data)
    : await api.post(`roles/${role.id}/users`, data);

  if (user && user.error) {
    throw new Error(user.error.message || "Unexpected Error");
  }

  return { type: types.SAVE, data: { user, role } };
};

export const remove = async (user, role) => {
  await api.delete(`roles/${role.id}/users/${user.id}`);
  return { type: types.DELETE, data: { user } };
};



// WEBPACK FOOTER //
// ./app/actions/users.js